// extracted by mini-css-extract-plugin
export var actionButton = "_8t-1";
export var actionButtons = "_8t-2";
export var actions = "_8t-0";
export var aiUnread = "_8t-10";
export var alignCenter = "_8t-h";
export var backWrapper = "_8t-3";
export var cellContainer = "_8t-4";
export var checkboxContainer = "_8t-5";
export var contentContainer = "_8t-6";
export var contentHeader = "_8t-8";
export var conversationsTableWrapper = "_8t-s";
export var draftReplyBadgeContainer = "_8t-m";
export var dropdownItem = "_8t-b";
export var dropdownItemsContainer = "_8t-a";
export var dropdownTitle = "_8t-c";
export var errorIcon = "_8t-7";
export var filter = "_8t-d";
export var gray = "_8t-i";
export var headerActionButtons = "_8t-e";
export var headerCheckboxContainer = "_8t-f";
export var icon = "_8t-j";
export var menuContainer = "_8t-k";
export var noMoreTicketsIcon = "_8t-12";
export var noMoreTicketsSubText = "_8t-13";
export var oneLine = "_8t-l";
export var optionsButton = "_8t-n";
export var plus = "_8t-o";
export var portalButtonsWrapper = "_8t-g";
export var red = "_8t-p";
export var scrolledTop = "_8t-9";
export var search = "_8t-q";
export var selectedConversationsCount = "_8t-r";
export var spinner = "_8t-t";
export var strong = "_8t-u";
export var summaryCell = "_8t-v";
export var tableContainer = "_8t-11";
export var tagContainer = "_8t-w";
export var threeDots = "_8t-x";
export var twoLines = "_8t-y";
export var unread = "_8t-z";